import { Button } from '@shared/components/Button';
import { MBIconV2Name } from '@shared/components/image';
import classNames from './MessageActionButton.module.css';

interface MessageActionButtonProps {
  onPress(): void;
  icon: MBIconV2Name;
  iconSize?: number;
  className?: string;
  testID?: string;
}

/**
 * One of the small icon buttons that appear beside a message on hover: a ghost Button whose
 * icon grows slightly on hover. Also used by the reaction button and by Ask's answer bubbles,
 * which carry buttons of their own in the same place — they have to be these buttons rather
 * than ones that merely resemble them. See `ReactionButton` and `AskMessageActions`.
 */
export function MessageActionButton({
  onPress,
  icon,
  iconSize,
  className,
  testID,
}: MessageActionButtonProps) {
  return (
    <Button
      variant="ghost"
      iconOnly
      icon={icon}
      iconSize={iconSize}
      onClick={onPress}
      testID={testID}
      className={[classNames.messageActionButton, className]}
    />
  );
}
